import AccountCircle from "@mui/icons-material/AccountCircle";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth-context";

export default function LoginView() {
    const navigate = useNavigate();

    const { login } = useAuth();
    const { user } = useAuth();
    const [error, setError] = useState();

    const [values, setValues] = useState({
        email: "",
        password: "",
        showPassword: false,
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async () => {
        try {
            await login(values.email, values.password);
            navigate("/experiments/list");
        } catch (error) {
            console.log(error.message);
            console.log(error.code);
            setError(error.message);
        }
    };

    useEffect(() => {
        if (user) {
            navigate("/experiments/list");
        }
    })
    

    return (
        <div className="container">
            <div className="login-form-container">
                <div className="login-form-title">
                    <div className="login-form-title__logo"></div>
                    <div className="login-form-title__subtitle">
                        🧪 Sandbox
                    </div>
                </div>
                <LoadingButton
                    onClick={handleSubmit}
                    className="login-form-element"
                    variant="contained">
                    Ingresar
                </LoadingButton>
            </div>
        </div>
    );
}
